import { render, staticRenderFns } from "./CheckinPaxInfo.vue?vue&type=template&id=9254a448&"
import script from "./CheckinPaxInfo.vue?vue&type=script&lang=js&"
export * from "./CheckinPaxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports